export default "__VITE_ASSET__C4F9kZZH__"